module.exports = __webpack_public_path__ + "img/abc.12b8c77b.png";